import React from 'react';
import { repository } from '@whizz/api-client';
import { useI18n } from '@whizz/react-i18n';
import { useQuery } from 'react-query';
import { Loader } from '../../components';
import { QUERIES_IDS } from '../../util/vars';
import { useModal } from '../../hooks/useModal';

const AdminModal = () => {

  const { translate } = useI18n();
  const staffQuery = useQuery(
    [ QUERIES_IDS.STAFF ],
    () => repository.StaffRepository.getStaff(),
  );

  const content = () => {
    if (!staffQuery.isSuccess) {
      return <Loader />;
    }
    const adminUsers = staffQuery.data?.teachers.filter((staff) => staff.isAdmin);
    if (!adminUsers) {
      return <p>{translate('globale.NO_ROSTER_MANAGEMENT.NO_ADMINS')}</p>;
    }
    return (
      <>
        <p>{translate('global.NO_ROSTER_MANAGEMENT.ADMINS_GIVE_ACCESS')}</p>
        <div className={'overflow-x-auto overflow-y-hidden p-sm'}>
          <ul className={'list-disc list-inside inline-block min-w-full'} style={{ columnCount: Math.ceil(adminUsers.length / 10) }}>
            {adminUsers.map((admin, index) => {
              const staffName = `${admin.firstName} ${admin.lastName}`;
              return (
                <li key={index} className={'whitespace-nowrap p-1'}>{staffName}</li>
              );
            })}
          </ul>
        </div>
      </>
    );
  };

  return (
    <div className={'container space-y-4'}>
      {content()}
    </div>
  );
};

const useAdminModal = (): [ React.ReactElement, (open: boolean) => void ] => {
  const { translate } = useI18n();
  const [ adminModal, toggleAdminModal ] = useModal(() => <AdminModal />, {
    title: translate('global.NO_ROSTER_MANAGEMENT.title'),
  });

  return [ adminModal, toggleAdminModal ];
};

export default AdminModal;
export { useAdminModal };
